import { PaymentMethod, SECURITY_DEPOSIT_VND } from '../common/constants';
import { IHotelPaymentOption } from '../types/hotelTypes';

export const getDepositAmountVnd = (paymentOptions?: IHotelPaymentOption[]) => {
  const depositOption = paymentOptions?.find((option) => option.type === PaymentMethod.SecurityDeposit);
  return depositOption?.depositAmount ?? SECURITY_DEPOSIT_VND;
};
